<h1 mat-dialog-title id="question-schools-title">Schools using this question</h1>
<mat-dialog-content>
  <p class="question-schools-dialog__lead">{{ data.questionLabel }}</p>
  <p class="question-schools-dialog__id">ID: {{ data.questionId }}</p>
  <mat-slide-toggle [(ngModel)]="includeDeactivated" labelPosition="before">Include deactivated schools</mat-slide-toggle>
  @if (listedSchools().length === 0 && unknownSchoolIds().length === 0) {
    <p>No schools in the current index have this question selected.</p>
  } @else {
    <ul class="question-schools-dialog__list">
      @for (school of listedSchools(); track school.id) {
        <li>
          <a [routerLink]="['/', school.id, 'questions']">{{ school.name }} ({{ school.id }})</a>
          @if (school.disabledDate) {
            <span class="question-schools-dialog__status">Deactivated</span>
          }
        </li>
      }
      @for (schoolId of unknownSchoolIds(); track schoolId) {
        <li>
          <a [routerLink]="['/', schoolId, 'questions']">{{ schoolId }}</a>
        </li>
      }
    </ul>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if ((auth.user | async)?.dev) {
    <button type="button" mat-stroked-button [disabled]="!aidYear" (click)="updateSchoolLists()">Propagate Question</button>
  }
  <button type="button" mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>
